import {IconProps} from '../../types/IconProps'

const AlertIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '18'}
      height={height || '18'}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M14.1339 10.9995L9.73385 3.13281C9.40052 2.46615 8.73385 2.13281 8.00052 2.13281C7.26719 2.13281 6.60052 2.46615 6.26719 3.13281L1.86719 10.9995C1.53385 11.5995 1.53385 12.3995 1.86719 12.9995C2.20052 13.5995 2.86719 13.9995 3.60052 13.9995H12.4005C13.1339 13.9995 13.7339 13.5995 14.1339 12.9995C14.5339 12.3995 14.4672 11.6661 14.1339 10.9995ZM13.0005 12.3328C12.9339 12.3995 12.8005 12.6661 12.4005 12.6661H3.60052C3.26719 12.6661 3.06719 12.4661 3.00052 12.3328C2.93385 12.1995 2.80052 11.9995 3.00052 11.6661L7.40052 3.73281C7.60052 3.39948 7.86719 3.39948 8.00052 3.39948C8.13385 3.39948 8.40052 3.39948 8.60052 3.73281L13.0005 11.6661C13.1339 11.9995 13.0005 12.2661 13.0005 12.3328Z'
        fill={color || 'black'}
      />
      <path
        d='M8.0026 6C7.6026 6 7.33594 6.26667 7.33594 6.66667V8.66667C7.33594 9.06667 7.6026 9.33333 8.0026 9.33333C8.4026 9.33333 8.66927 9.06667 8.66927 8.66667V6.66667C8.66927 6.26667 8.4026 6 8.0026 6Z'
        fill={color || 'black'}
      />
      <path
        d='M8.0026 11.3333C8.37079 11.3333 8.66927 11.0349 8.66927 10.6667C8.66927 10.2985 8.37079 10 8.0026 10C7.63441 10 7.33594 10.2985 7.33594 10.6667C7.33594 11.0349 7.63441 11.3333 8.0026 11.3333Z'
        fill={color || 'black'}
      />
    </svg>
  )
}

export default AlertIcon
